import { render, staticRenderFns } from "./start-study.vue?vue&type=template&id=0ec0b2b2&"
import script from "./start-study.vue?vue&type=script&lang=ts&"
export * from "./start-study.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports